const theme = {
  backgroundColor: '#FFFFFF',
  fontColor: 'rgba(0, 0, 0, 0.65)',
  buttonColor: '#1890ff',
  colorPrimary: '#BDBDBD',
  colorGrey: '#1890ff',
  colorLightGrey: '#1890ff',
  linkColor: '#1890ff',
  success: {
    textColor: '#388E3C',
    backgroundColor: 'rgba(0,201,167,.1)'
  },
  notRequired: {
    textColor: '#77838f',
    backgroundColor: 'rgba(119,131,143,.1)'
  },
  failed: {
    textColor: '#de4437',
    backgroundColor: 'rgba(222,68,55,.1)'
  },
  warning: {
    textColor: '#ffa758',
    backgroundColor: 'rgba(222,68,55,.1)'
  }
}
export default theme
